import {Grid} from "@mui/material";
import MDBox from "../../../components/MDBox";
import MDTypography from "../../../components/MDTypography";
import {CalendarIcon} from "@mui/x-date-pickers";
import React from "react";

export default function EventMembershipDetail({membership}) {

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={2} md={3}>
          <center>
            <span style={{fontSize: '32px'}}><CalendarIcon/></span>
          </center>
        </Grid>
        <Grid item xs={12} sm={10} md={9}>
          <MDBox>
            <h2>
              Member Account Event Registration
            </h2>
            <h3>
              Account: {membership.name}
            </h3>
          </MDBox>
        </Grid>
      </Grid>
    </>
  )
}